import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/table';
import { Button } from '../../components/ui/button';
import { Users, Download, CheckCircle, UserX, MessageSquare, Mail, Phone } from 'lucide-react';
import { StatusBadge } from './shared';

export const ClientsTab = ({ allUsers, handleExport }) => {
  return (
    <Card className="border-0 shadow-lg">
      <CardHeader>
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
          <div>
            <CardTitle className="text-xl flex items-center gap-2">
              <Users className="w-5 h-5 text-[#C81D25]" />Todos los Clientes
            </CardTitle>
            <CardDescription>{allUsers.length} usuario(s) registrados en total</CardDescription>
          </div>
          <div className="flex gap-2">
            <Button variant="outline" size="sm" onClick={() => handleExport('users')} className="border-gray-300">
              <Download className="w-4 h-4 mr-2" />Exportar Todos
            </Button>
            <Button variant="outline" size="sm" onClick={() => handleExport('prospects')} className="border-amber-300 text-amber-700">
              <Download className="w-4 h-4 mr-2" />Exportar Prospectos
            </Button>
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <div className="overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow className="bg-gray-50">
                <TableHead className="font-semibold">Nombre</TableHead>
                <TableHead className="font-semibold">Email</TableHead>
                <TableHead className="font-semibold">Teléfono</TableHead>
                <TableHead className="font-semibold">Tipo</TableHead>
                <TableHead className="font-semibold">Estado</TableHead>
                <TableHead className="font-semibold">INE</TableHead>
                <TableHead className="font-semibold">Registro</TableHead>
                <TableHead className="font-semibold text-center">Refs</TableHead>
                <TableHead className="font-semibold text-center">Contactar</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {allUsers.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={9} className="text-center py-12 text-gray-400">No hay clientes registrados</TableCell>
                </TableRow>
              ) : (
                allUsers.map((u) => {
                  const beneficiaryLabel = u.beneficiary_type === 'self' ? 'Personal' : u.beneficiary_type === 'minor' ? 'Menor' : u.beneficiary_type === 'gift' ? 'Regalo' : 'Personal';
                  return (
                    <TableRow key={u.id} className={!u.has_membership ? 'bg-amber-50/50' : ''}>
                      <TableCell className="font-medium">
                        {u.name}
                        {u.beneficiary_name && <p className="text-xs text-gray-400">Beneficiario: {u.beneficiary_name}</p>}
                      </TableCell>
                      <TableCell className="text-gray-500 text-sm">{u.email}</TableCell>
                      <TableCell className="text-gray-500 text-sm">{u.phone || '-'}</TableCell>
                      <TableCell className="text-sm">{beneficiaryLabel}</TableCell>
                      <TableCell>
                        {u.has_membership ? (
                          <StatusBadge status={u.membership_status} />
                        ) : (
                          <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-semibold bg-red-100 text-red-700">
                            <UserX className="w-3 h-3" />Sin compra
                          </span>
                        )}
                      </TableCell>
                      <TableCell>
                        {u.ine_uploaded ? (
                          <span className="text-emerald-600 text-xs flex items-center gap-1"><CheckCircle className="w-3 h-3" />Sí</span>
                        ) : (
                          <span className="text-gray-400 text-xs">No</span>
                        )}
                      </TableCell>
                      <TableCell className="text-gray-500 text-sm">{u.created_at ? new Date(u.created_at).toLocaleDateString('es-MX') : '-'}</TableCell>
                      <TableCell className="text-center">
                        {u.referral_count > 0 ? (
                          <span className="bg-emerald-100 text-emerald-700 px-2 py-0.5 rounded-full text-xs font-bold" title={`Código: ${u.referral_code}`}>{u.referral_count}</span>
                        ) : u.referred_by_code ? (
                          <span className="text-xs text-blue-500" title={`Referido con: ${u.referred_by_code}`}>Ref</span>
                        ) : (
                          <span className="text-gray-300 text-xs">-</span>
                        )}
                      </TableCell>
                      <TableCell className="text-center">
                        <div className="flex items-center justify-center gap-1">
                          {u.phone && (
                            <a href={`https://wa.me/52${u.phone.replace(/\D/g, '')}`} target="_blank" rel="noopener noreferrer"
                              className="inline-flex items-center justify-center w-8 h-8 rounded-lg hover:bg-emerald-50 text-emerald-600 transition-colors" title="WhatsApp">
                              <MessageSquare className="w-4 h-4" />
                            </a>
                          )}
                          <a href={`mailto:${u.email}`}
                            className="inline-flex items-center justify-center w-8 h-8 rounded-lg hover:bg-blue-50 text-blue-600 transition-colors" title="Email">
                            <Mail className="w-4 h-4" />
                          </a>
                          {u.phone && (
                            <a href={`tel:${u.phone}`}
                              className="inline-flex items-center justify-center w-8 h-8 rounded-lg hover:bg-gray-100 text-gray-600 transition-colors" title="Llamar">
                              <Phone className="w-4 h-4" />
                            </a>
                          )}
                        </div>
                      </TableCell>
                    </TableRow>
                  );
                })
              )}
            </TableBody>
          </Table>
        </div>
      </CardContent>
    </Card>
  );
};
